const boatTypes = [
  {
    key: 'all',
    label: 'All',
    default: true
  },
  {
    key: 'OpenPowerBoats',
    label: 'Open Power Boats'
  },
  {
    key: 'CabinPowerBoats',
    label: 'Cabin Power Boats'
  },
  {
    key: 'PontoonBoats',
    label: 'Pontoon Boats'
  },
  // {
  //   key: 'AirBoats',
  //   label: 'Air Boats'
  // },
  // {
  //   key: 'HouseBoats',
  //   label: 'House Boats'
  // },
  {
    key: 'PWCs',
    label: 'Personal Watercraft (PWC)'
  },
  // {
  //   key: 'AuxiliarySailBoats',
  //   label: 'Auxiliary Sail Boats'
  // },
  {
    key: 'Sailboats',
    label: 'Sail Boats'
  },
  {
    key: 'Canoes',
    label: 'Canoes'
  },
  {
    key: 'Kayaks',
    label: 'Kayaks'
  },
  {
    key: 'Paddleboards',
    label: 'Paddleboards'
  },
  {
    key: 'RowedBoats',
    label: 'Rowed Boats'
  },
  {
    key: 'AllOther',
    label: 'All Other'
  }
]
export default boatTypes
